// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__4JJQ4","menuItem":"Menu_menuItem__zJzJh","header":"Menu_header__ZYwfZ","divider":"Menu_divider__kKsCD"};